import { render, staticRenderFns } from "./PatientDinamics.vue?vue&type=template&id=79ab6bb5&"
import script from "./PatientDinamics.vue?vue&type=script&lang=js&"
export * from "./PatientDinamics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports